import useCachedFeatureFlagWithPrefs from './useCachedFeatureFlagWithPrefs'

export default function useSourceCentricDetailsFlag(): ReturnType<typeof useCachedFeatureFlagWithPrefs> {
  return useCachedFeatureFlagWithPrefs('treeWeb_personR9_sourceCentricDetails', 'tree-person.sourceCentricDetails', {
    userPreferences: ['softLaunch.treeWeb_personR9_sourceCentricDetails'],
  })
}
